import React from "react";

export const IconSingle = ({ active, color }) => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none">
    <rect x="1" y="1" width="20" height="16" rx="2" stroke={color} strokeWidth="1.5" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
  </svg>
);

export const IconTwoCols = ({ active, color }) => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none">
    <rect x="1" y="1" width="9" height="16" rx="2" stroke={color} strokeWidth="1.5" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="12" y="1" width="9" height="16" rx="2" stroke={color} strokeWidth="1.5" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
  </svg>
);

export const IconTwoRows = ({ active, color }) => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none">
    <rect x="1" y="1" width="20" height="7" rx="2" stroke={color} strokeWidth="1.5" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="1" y="10" width="20" height="7" rx="2" stroke={color} strokeWidth="1.5" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
  </svg>
);

export const IconThreeCols = ({ active, color }) => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none">
    <rect x="1" y="1" width="5.3" height="16" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="8.3" y="1" width="5.3" height="16" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="15.6" y="1" width="5.3" height="16" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
  </svg>
);

export const IconThreeRows = ({ active, color }) => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none">
    <rect x="1" y="1" width="20" height="4" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="1" y="7" width="20" height="4" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="1" y="13" width="20" height="4" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
  </svg>
);

export const IconThreeTopSplit = ({ active, color }) => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none">
    <rect x="1" y="1" width="20" height="7" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="1" y="10" width="9" height="7" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="12" y="10" width="9" height="7" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
  </svg>
);

export const IconThreeBottomSplit = ({ active, color }) => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none">
    <rect x="1" y="1" width="9" height="7" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="12" y="1" width="9" height="7" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="1" y="10" width="20" height="7" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
  </svg>
);

export const IconFourGrid = ({ active, color }) => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none">
    <rect x="1" y="1" width="9" height="7" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="12" y="1" width="9" height="7" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="1" y="10" width="9" height="7" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="12" y="10" width="9" height="7" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
  </svg>
);

export const IconFourCols = ({ active, color }) => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none">
    <rect x="1" y="1" width="3.7" height="16" rx="1" stroke={color} strokeWidth="1.1" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="6.4" y="1" width="3.7" height="16" rx="1" stroke={color} strokeWidth="1.1" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="11.8" y="1" width="3.7" height="16" rx="1" stroke={color} strokeWidth="1.1" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="17.2" y="1" width="3.7" height="16" rx="1" stroke={color} strokeWidth="1.1" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
  </svg>
);

export const IconFourLeftMain = ({ active, color }) => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none">
    <rect x="1" y="1" width="12" height="16" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="15" y="1" width="6" height="4" rx="1" stroke={color} strokeWidth="1.1" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="15" y="7" width="6" height="4" rx="1" stroke={color} strokeWidth="1.1" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="15" y="13" width="6" height="4" rx="1" stroke={color} strokeWidth="1.1" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
  </svg>
);

export const IconFourTopMain = ({ active, color }) => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none">
    <rect x="1" y="1" width="20" height="9" rx="1.5" stroke={color} strokeWidth="1.2" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="1" y="12" width="5.3" height="5" rx="1" stroke={color} strokeWidth="1.1" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="8.3" y="12" width="5.3" height="5" rx="1" stroke={color} strokeWidth="1.1" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
    <rect x="15.6" y="12" width="5.3" height="5" rx="1" stroke={color} strokeWidth="1.1" fill={active ? color : "none"} fillOpacity={active ? 0.2 : 0} />
  </svg>
);

export const getLayoutIcon = (id, active, color) => {
  switch (id) {
    case "1": return <IconSingle active={active} color={color} />;
    case "2-cols": return <IconTwoCols active={active} color={color} />;
    case "2-rows": return <IconTwoRows active={active} color={color} />;
    case "3-cols": return <IconThreeCols active={active} color={color} />;
    case "3-rows": return <IconThreeRows active={active} color={color} />;
    case "3-top-split": return <IconThreeTopSplit active={active} color={color} />;
    case "3-bottom-split": return <IconThreeBottomSplit active={active} color={color} />;
    case "4-grid": return <IconFourGrid active={active} color={color} />;
    case "4-cols": return <IconFourCols active={active} color={color} />;
    case "4-left-main": return <IconFourLeftMain active={active} color={color} />;
    case "4-top-main": return <IconFourTopMain active={active} color={color} />;
    default: return <IconSingle active={active} color={color} />;
  }
};
